import React from "react";
import LightGallery from "lightgallery/react";
import "lightgallery/css/lightgallery.css";
import "lightgallery/css/lg-zoom.css";
import "lightgallery/css/lg-thumbnail.css";
import lgThumbnail from "lightgallery/plugins/thumbnail";
import lgZoom from "lightgallery/plugins/zoom";
import { BASE_NAME } from "config";
import { ImageElement } from "..";

function ImageGallery({ images, isTeamLabel }) {
  const onInit = () => {};

  return (
    <LightGallery
      onInit={onInit}
      elementClassNames="gallery-container row gx-2 gy-2"
      speed={500}
      mobileSettings={{
        controls: true,
        showCloseIcon: true,
        download: true,
      }}
      plugins={[lgThumbnail, lgZoom]}
    >
      {images?.map((item, index) => (
        <a
          key={index}
          className={`imgGrid_item ${
            isTeamLabel ? "col-lg-6 col-sm-6" : "col-lg-4 col-sm-6"
          }`}
          // href={`${BASE_NAME}/assets/images/${item?.image}`}
          href={`${BASE_NAME}/assets/images/dummy-img.webp`}
        >
          <ImageElement
            imageFor="user"
            // source={`${item?.image}`}
            source="dummy-img.webp"
            className="img-fluid"
            alt="floor-plan"
          />
          <h2 className="imgGrid_item_label text-uppercase mt-1">
            {item?.name}
          </h2>
        </a>
      ))}
    </LightGallery>
  );
}

export default ImageGallery;
